// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"d1d377fc","59":"737c8807","252":"f4c342ba","253":"96780f8a","340":"474064b2","360":"a2501a55","377":"b9449198","545":"2fe16fc3","589":"e5588607","659":"f5251a65","695":"466ce9db","738":"4bdb5b29","935":"e6fe8c11"}[chunkId] + ".chunk.js";
};